import { HttpErrorResponse, type HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { tap } from 'rxjs';
import { SessionExpiryService } from '../services/session-expiry.service';

export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
    const platformId = inject(PLATFORM_ID);
    if (!isPlatformBrowser(platformId)) return next(req);

    const sessionExpiry = inject(SessionExpiryService);

    return next(req).pipe(
        tap({
            error: (err: unknown) => {
                if (!(err instanceof HttpErrorResponse)) return;
                if (err.status !== HttpStatusCode.Unauthorized && err.status !== HttpStatusCode.Forbidden) return;
                // A 401 on the login POST is "wrong credentials", not an expired session.
                if (req.url.includes('/auth/login')) return;
                void sessionExpiry.expire();
            },
        }),
    );
};
